import {createGlobalStyle} from 'styled-components';

const GlobalStyle = createGlobalStyle`
    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    html{
        @media (max-width: 1300px){
            font-size: 75%;
        }
    }

    body{
        background: white;
        font-family: "Raleway", sans-serif;
    }

    a{
        text-decoration: none;
        font-weight: 500;
    }
    p{
        font-size: 1.5rem;
    }
    h1{
        font-size: 8rem;
    }
    h3{
        font-size: 5.5rem;
    }
    h4{
        font-size: 2rem;
    }
    h5{
        font-size: 3rem;
    }
    input, select{
        font-family: "Raleway", sans-serif;
    }

    @media (max-width: 768px){
        h1{
            font-size: 7rem;
        }
        h3{
            font-size: 2.5rem;
        }
        h5{
            font-size: 2rem;
        }
    }
`

export default GlobalStyle;